import * as React from 'react';
const PageDashboard = React.lazy(
  () => import('./Demo/Dashboard/PageDashboard'),
);
const PageHome = React.lazy(() => import('./Demo/Dashboard/Sales'));
const PageKasir = React.lazy(() => import('./Demo/Panels/Hospital/PageKasir'));
const PageRegistrasi = React.lazy(
  () => import('./Demo/Panels/Ecommerce/PageRegistrasi'),
);
const PageOffice = React.lazy(
  () => import('./Demo/Panels/Ecommerce/PageOffice'),
);
const PageOfficeLaporan = React.lazy(
  () => import('./App/Office/laporan-detail'),
);
const PageEMR = React.lazy(() => import('./Demo/Panels/Ecommerce/PageEMR'));
const PageDataMaster = React.lazy(
  () => import('./Demo/UIElements/Advance/PageDataMaster'),
);
const PageInventory = React.lazy(
  () => import('./Demo/UIElements/Advance/PageInventory'),
);
const PageSetting = React.lazy(
  () => import('./Demo/UIElements/Advance/PageSetting'),
);
export const loadAppointmentPage = () => import('./Demo/Extension/PageAppointment');
const PageAppointment = React.lazy(loadAppointmentPage);

const PageAnalytics = React.lazy(() => import('./App/Dashboard'));
const CTICommandCenter = React.lazy(() => import('./App/CTICommandCenter'));
const EdukasiPasien = React.lazy(() => import('./App/edukasi-pasien'));
const InsuranceGuide = React.lazy(() => import('./App/insurance-guide'));
const Asuransi = React.lazy(() => import('./App/Asuransi'));
const ErrorPage = React.lazy(() => import('./App/404'));
const WelcomeGreeting = React.lazy(() => import('./App/welcome-greeting'));
const RefundGuide = React.lazy(() => import('./App/refund-guide'));

const routes = [
  // {
  //   path: '/dashboard',
  //   exact: true,
  //   name: 'Analytics',
  //   component: PageDashboard,
  //   permission: 'a1',
  // },
  {
    path: '/404',
    exact: true,
    name: 'ErrorPage',
    component: ErrorPage,
    permission: 'a1',
  },
  {
    path: '/home',
    exact: true,
    name: 'Analytics',
    component: PageHome,
    permission: 'a1',
  },
  {
    path: '/appointment',
    exact: true,
    name: 'Full Calendar',
    component: PageAppointment,
    permission: 'b1',
  },
  {
    path: '/registrasi/*',
    exact: false,
    name: 'Ecommerce Checkout',
    component: PageRegistrasi,
    permission: 'c1',
  },
  {
    path: '/emr',
    exact: true,
    name: 'Ecommerce Customers',
    component: PageEMR,
    permission: 'd1',
  },
  {
    path: '/inventory/*',
    exact: false,
    name: 'Datepicker',
    component: PageInventory,
    permission: 'e1',
  },
  {
    path: '/kasir/*',
    exact: false,
    name: 'Hospital Department',
    component: PageKasir,
    permission: 'f1',
  },
  {
    path: '/office/laporan-detail/*',
    exact: false,
    name: 'Ecommerce Cart',
    component: PageOfficeLaporan,
    permission: 'g353',
  },
  {
    path: '/office/*',
    exact: false,
    name: 'Ecommerce Cart',
    component: PageOffice,
    permission: 'g353',
  },
  {
    path: '/setting/*',
    exact: false,
    name: 'Light Box',
    component: PageSetting,
    permission: 'h1',
  },
  {
    path: '/dataMaster/*',
    exact: false,
    name: 'Sweet Alert',
    component: PageDataMaster,
    permission: 'i158',
  },
  {
    path: '/dashboard/*',
    exact: false,
    name: 'Sweet Alert',
    component: PageAnalytics,
    permission: 'j1',
  },
  {
    path: '/cti-command-center',
    exact: true,
    name: 'CTI Command Center',
    component: CTICommandCenter,
    permission: 'j1',
  },
  {
    path: '/edukasi-pasien',
    exact: false,
    name: 'Scan QR',
    component: EdukasiPasien,
    permission: 'k1',
  },
  {
    path: '/welcome-greeting',
    exact: false,
    name: 'Welcome Greeting',
    component: WelcomeGreeting,
    permission: 'l1',
  },
  {
    path: '/helpy',
    exact: false,
    name: 'Welcome Greeting',
    component: WelcomeGreeting,
    permission: 'l1',
  },
  {
    path: '/insurance-guide',
    exact: false,
    name: 'Panduan Asuransi',
    component: InsuranceGuide,
    permission: 'n1',
  },
  {
    path: '/asuransi',
    exact: false,
    name: 'Asuransi',
    component: Asuransi,
    permission: 'o0',
  },
  {
    path: '/refund-guide',
    exact: false,
    name: 'Panduan Refund',
    component: RefundGuide,
    permission: 'p1',
  },
];

export default routes;
